export default __webpack_public_path__ + "static/media/4.a498e2e1.jpg";